module.exports = __webpack_public_path__ + "img/fc.2cd91e84.png";